import { createFileRoute, redirect } from '@tanstack/react-router'
import { resolveLandingPath } from '@/config/navigation'
import { useAuthStore } from '@/features/auth/stores/auth.store'
import { unauthenticatedRedirect } from '@/app/router/route-guards'

/**
 * Root path. Signed-in users are sent to their role-based landing page — the
 * first sidebar tab they can access — otherwise out to sign-in.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const user = useAuthStore.getState().user
    if (user) {
      throw redirect({ to: resolveLandingPath(user) })
    }
    throw unauthenticatedRedirect()
  },
})
